// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dragging-text[data-v-f9bd23e4] .input {\n\twidth: 95%;\n\tvertical-align: middle;\n}\n.dragging-text[data-v-f9bd23e4] .character-count {\n\tfont-size: 0.7em;\n\tmargin: 5px 0;\n}\n.dragging-text[data-v-f9bd23e4] .control {\n\tmargin-right: 25px;\n}\n.dragging-text[data-v-f9bd23e4] .counter {\n\tmargin-right: 5%;\n\tvisibility: visible !important;\n}\n", ""]);
// Exports
module.exports = exports;
